import { render, staticRenderFns } from "./OrderShipmentsNew.vue?vue&type=template&id=ca5a7ba4&scoped=true&"
import script from "./OrderShipmentsNew.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5a7ba4",
  null
  
)

export default component.exports